import React from "react";
import { connect } from "react-redux";
import { AppLayoutHeader } from "../../components/layouts/header/app-layout-header";
import { reportServerError } from "../../redux/modules/UI/actions";
import { Box, Button, Typography } from "@mui/material";

const appLayoutHOC = (ComposedComponent) => {
  class AppLayoutHOC extends React.Component<any, any> {
    constructor(props) {
      super(props);
      this.state = {
        pageConfig: {
          showLogo: true,
        },
      };
    }

    handlePageConfig = (config) => {
      this.setState({
        pageConfig: {
          ...this.state.pageConfig,
          ...config,
        },
      });
    };

    handleClearError = () => {
      this.props.dispatchReportServerError({
        error: false,
        message: "",
        responseStatus: null,
      });
    };

    render() {
      const { isServerError } = this.props;

      return (
        <>
          <AppLayoutHeader configs={this.state.pageConfig} />
          {isServerError?.error ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "400px",
                textAlign: "center",
                p: 4,
              }}
            >
              <Typography variant="h4" sx={{ mb: 2, color: "error.main" }}>
                {isServerError.message || "Something went wrong"} <b>:(</b>
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                {isServerError.responseStatus === 401
                  ? "You can go back to our Login page."
                  : "An error occurred while processing your request."}
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="outlined"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
              </Box>
            </Box>
          ) : (
            <ComposedComponent
              {...this.props}
              setConfig={this.handlePageConfig}
            />
          )}
        </>
      );
    }
  }

  const mapStateToProps = (state) => {
    return {
      isServerError: state.UI.isServerError,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      dispatchReportServerError: (payload) => dispatch(reportServerError(payload)),
    };
  };

  return connect(mapStateToProps, mapDispatchToProps)(AppLayoutHOC);
};

export default appLayoutHOC;
